import { render, staticRenderFns } from "./GelirGiderForm.vue?vue&type=template&id=3281f9d4"
import script from "./GelirGiderForm.vue?vue&type=script&lang=ts"
export * from "./GelirGiderForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports